import {
	getNativeEmbedCommentSupportStore,
	NativeEmbedCommentSupportStore,
} from '@atlaskit/native-embeds-common/comment-support-store';

import {
	type ExperienceManifest,
	type ExperienceManifestId,
} from '../../common/types/experience/types';

let experienceService: ExperienceManifestRegistry | undefined;

export function getExperienceManifestRegistry(): ExperienceManifestRegistry {
	if (experienceService) {
		return experienceService;
	}
	experienceService = new ExperienceManifestRegistry(getNativeEmbedCommentSupportStore());
	return experienceService;
}

export class ExperienceManifestRegistry {
	private experienceManifests: ExperienceManifest[] = [];
	constructor(
		private readonly commentSupport: NativeEmbedCommentSupportStore = new NativeEmbedCommentSupportStore(),
	) {}

	registerExperienceManifest(experienceManifest: ExperienceManifest): void {
		this.experienceManifests.push(experienceManifest);
		this.commentSupport.register(
			experienceManifest.id,
			experienceManifest.comments?.enabled === true,
		);
	}

	private safeIsUrlMatch(experience: ExperienceManifest, url: string): boolean {
		try {
			return experience.isUrlMatch(url);
		} catch {
			return false;
		}
	}

	getExperienceIdFromUrl(url: string): ExperienceManifestId | undefined {
		return this.experienceManifests.find((experience) => this.safeIsUrlMatch(experience, url))?.id;
	}

	getManifestByUrl(url: string): ExperienceManifest | undefined {
		return this.experienceManifests.find((experience) => this.safeIsUrlMatch(experience, url));
	}

	getManifestById(id: string): ExperienceManifest | undefined {
		return this.experienceManifests.find((experience) => experience.id === id);
	}

	getAllExperienceIds(): ExperienceManifestId[] {
		return this.experienceManifests.map((experience) => experience.id);
	}

	async getExperienceById(id: string): Promise<ExperienceManifest | undefined> {
		return this.experienceManifests.find((experience) => experience.id === id);
	}
}
